"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const store_1 = require("@ngrx/store");
const ngrx_store_freeze_1 = require("ngrx-store-freeze");
const environment_1 = require("environments/environment");
exports.metaReducers = !environment_1.environment.production ? [ngrx_store_freeze_1.storeFreeze] : [];
class AppStoreModule {
}
exports.AppStoreModule = AppStoreModule;
